import { render } from "./FullscreenImage.vue?vue&type=template&id=451677ba"
import script from "./FullscreenImage.vue?vue&type=script&lang=js"
export * from "./FullscreenImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__